import { theme } from 'lib/theme';
import { View, ViewProps } from 'react-native';

const size = theme.padding / 2;

export const GapSmall = ({
  children,
  disabled,
  style,
}: {
  children: React.ReactNode;
  disabled?: boolean;
  style?: ViewProps['style'];
}) => {
  return (
    <View
      style={[
        {
          gap: disabled ? 0 : size,
        },
        style,
      ]}
    >
      {children}
    </View>
  );
};
